import HasGroupAccess from "@/permissions/HasGroupAccess";
import { GROUP_NAME } from "@/modules/julho_14/settings";

const hasGroupAcess = HasGroupAccess(GROUP_NAME);

function hasAccess() {
  return hasGroupAcess.hasPermission();
}

export default hasAccess;
